import type {
	AdminAuditFilters,
	AdminAuditRow,
	ListAdminAuditParams,
} from "@/features/audit/types";
import { toAdminSearchParams } from "@/shared/api/admin-list";
import { api } from "@/shared/api/client";
import type { InfinityPage } from "@/shared/api/types";

export function toAuditSearchParams(
	params: ListAdminAuditParams,
): URLSearchParams {
	const search = toAdminSearchParams({
		search: params.search,
		page: params.page,
		limit: params.limit,
		sort: params.sort ?? "createdAt",
		order: params.order ?? "DESC",
	});
	if (params.actorId) {
		search.set("actorId", params.actorId);
	}
	if (params.action) {
		search.set("action", params.action);
	}
	if (params.from) {
		search.set("from", params.from);
	}
	if (params.to) {
		search.set("to", params.to);
	}
	return search;
}

export async function listAdminAudit(
	params: ListAdminAuditParams = {},
): Promise<InfinityPage<AdminAuditRow>> {
	return api
		.get("admin/audit-log", { searchParams: toAuditSearchParams(params) })
		.json();
}

export async function getAdminAuditFilters(): Promise<AdminAuditFilters> {
	return api.get("admin/audit-log/filters").json();
}

export const auditKeys = {
	list: (params: ListAdminAuditParams) =>
		["admin-audit", "list", params] as const,
	filters: ["admin-audit", "filters"] as const,
};
